import { useEffect, useState } from 'react';

/**
 * Initializes Theatre.js Studio in development (`?theatre` in the URL).
 *
 * The project module is imported lazily, inside the dev branch. A static
 * `import { project } from '../theatre/project'` here pulled @theatre/core
 * (33 KB gzipped) into every production page view, for a project whose
 * saved state is empty and which no reachable component reads. Anything
 * that does need the project imports `theatre/project` itself.
 */
export const useTheatre = () => {
  const [studio, setStudio] = useState(null);

  useEffect(() => {
    if (!import.meta.env.DEV || !new URLSearchParams(window.location.search).has('theatre')) return;
    (async () => {
      try {
        await import('../theatre/project');
        const { initStudio } = await import('../theatre/studio');
        setStudio(await initStudio());
      } catch (error) {
        console.warn('[Theatre.js] Studio not available:', error);
      }
    })();
  }, []);

  return { studio };
};
